<template>
  <mdb-container class="gp-has-header">
    <div v-show="showMain" class="text-left">
      <data-table :clickHandler="openBrand"
                  :columns="columns"
                  add-label="Add new Brand/Affiliate"
                  show-add-button
                  :add-handler="newBrand"
                  dataSource="/affiliate/list"
                  pageTitle="Brands/Affiliates"/>
    </div>

    <editor-wizard v-if="showWizard" @cancel="showWizard=false" @pageGenerated="wizardDone" :prefill="wizardData"/>

    <div v-if="showBrand && currentBrand && !showWizard">
      <mdb-card>
        <mdb-card-body class="text-left">
          <mdb-btn icon="arrow-left" rounded size="sm" @click="cancelShow">Brand List</mdb-btn>
          <mdb-btn icon="database" rounded size="sm" @click="$router.push('/admin/dashboard')">Admin Dashboard</mdb-btn>

          <mdb-card class="mb-2" v-if="currentBrand.id">
            <mdb-card-header>
              <h5>Brand/Affiliate: {{ currentBrand.name }}</h5>
            </mdb-card-header>
            <mdb-card-body>
              <h4>Primary Owner</h4>
              <div>
                <avatar :avatar="currentBrand.primaryOwnerAvatar" :name="currentBrand.primaryOwnerName"/>
                {{ currentBrand.primaryOwnerName }}
              </div>
              <div style="clear:both;" v-if="currentBrand.primaryOwnerId">
                <mdb-btn icon="search" rounded size="sm" @click="$router.push('/users/'+currentBrand.primaryOwnerId)">
                  Owner
                  Details
                </mdb-btn>
                <mdb-btn icon="pencil" color="warning" rounded size="sm"
                         @click="$router.push('/admin/brandOwnerChange/'+ currentBrand.id)">
                  Change
                  Owner
                </mdb-btn>
                <mdb-btn v-if="currentUser.isAdmin" icon="user" color="warning" rounded size="sm" @click="proxyOwner">
                  Proxy Owner
                </mdb-btn>
                <mdb-btn icon="envelope" rounded size="sm"
                         @click="$router.push('/conversations?start='+currentBrand.primaryOwnerId)">Message Owner
                </mdb-btn>
              </div>
              <div style="clear:both;" v-if="!currentBrand.primaryOwnerId">
                <h3>None Set</h3>
                <mdb-btn icon="pencil" color="warning" rounded size="sm"
                         @click="$router.push('/admin/brandOwnerChange/'+ currentBrand.id)">
                  Set Primary Owner
                </mdb-btn>
              </div>
            </mdb-card-body>
          </mdb-card>
          <mdb-card class="mb-2">
            <mdb-card-header>
              <h5>Settings</h5>
            </mdb-card-header>
            <mdb-card-body>

              <mdb-input type="text" v-model="currentBrand.name"
                         label="Brand/Affiliate Name"/>
              <mdb-input type="text" v-model="currentBrand.affiliateCode"
                         label="Affiliate Code"/>
              <div class="form-check">
                <input aria-label="Public?" class="form-control form-check-input" id="isPublic" type="checkbox"
                       v-model="currentBrand.isPublic"/>
                <label for="isPublic">Public?</label>
              </div>
              <mdb-input type="text" v-model="currentBrand.uriName"
                         label="URI Path"/>
              <div class="text-info small" v-if="currentBrand.uriName">
                URL: {{ config.frontEndUrl }}/affiliate/{{ currentBrand.uriName }}
                <mdb-btn icon="copy" size="sm" floating tag="a" @click="copyLink">Copy to Clipboard</mdb-btn>
              </div>
              <div class="mb-4 border">
                <div class="formless-label">Affiliate Home Page</div>
                <div id="text-wizard-area" class="grey lighten-5 border">
                  <editor v-model="currentBrand.homeHtml" :init="editorConfig"></editor>
                </div>
                <div class="gp-end-wrap">
                  <mdb-btn icon="hat-wizard" rounded size="sm" @click="showWizard=true">Use Page Wizard</mdb-btn>
                </div>
              </div>

              <mdb-btn @click="save" icon="save" color="success">Save</mdb-btn>
            </mdb-card-body>
          </mdb-card>
          <mdb-card class="mb-2" v-if="currentBrand.id">
            <mdb-card-header>
              <h5>Auto Join Group(s)</h5>
            </mdb-card-header>
            <mdb-card-body>
              <mdb-list-group>
              <mdb-list-group-item v-for="g in currentBrand.defaultGroups" :key="g.id">
                {{ g.name }} <mdb-btn @click="removeGroup(g)" color="danger" icon="trash" size="sm" rounded>Remove</mdb-btn>
              </mdb-list-group-item>
              </mdb-list-group>
              <mdb-btn @click="addGroupModal=true" icon="plus-circle" size="sm" rounded>Add Group</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-2" v-if="currentBrand.id">
        <mdb-card-header>
          <h5>Global Group</h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-row>
            <mdb-col col="7">
              <mdb-input type="text" disabled :value="currentBrand.globalGroupName"
                         label="Global Group"/>
              <div class="text-info small">A member is automatically enrolled in an associated
                Global Group when joining a group in the brand/affiliate.
              </div>
            </mdb-col>
            <mdb-col>
              <mdb-btn @click="changeGlobalGroupModal = true" rounded
                       size="sm"
                       icon="pencil">
                Change
              </mdb-btn>
              <mdb-btn @click="yesNoModal = true" rounded
                       v-if="currentBrand.globalGroupName"
                       size="sm" color="danger"
                       icon="trash">
                Remove
              </mdb-btn>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>
    <mdb-modal v-if="changeGlobalGroupModal"
               size="lg"
               @close="changeGlobalGroupModal = false">
      <mdb-modal-header class="secondary-color text-white">
        <h5>Change Global Group</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <data-table-advanced queryName="GroupQuery"
                             :actions="groupActions"
                             :additional-parameters="{currentTenantOnly: true}"
                             @handleAction="changeGlobalGroup"
                             :pageTitle="capitalize($tc('common.label.group',2)) "/>

        <mdb-btn color="warning" icon="times-circle" @click="changeGlobalGroupModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal v-if="addGroupModal"
               size="lg"
               @close="addGroupModal = false">
      <mdb-modal-header class="secondary-color text-white">
        <h5>Add Default Group</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <data-table-advanced queryName="GroupQuery"
                             :actions="groupActions"
                             :additional-parameters="{currentTenantOnly: true}"
                             @handleAction="addDefaultGroup"
                             :pageTitle="capitalize($tc('common.label.group',2))"/>

        <mdb-btn color="warning" icon="times-circle" @click="addGroupModal = false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>



    <yes-no-modal v-if="yesNoModal" @yes="deleteGlobalGroup" @no="yesNoModal=false"/>
    <yes-no-modal v-if="removeGroupModal" @yes="doRemoveGroup" @no="removeGroupModal=false"/>

  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import dataTableAdvanced from '../common/DataTableAdvanced'
import editor from '@tinymce/tinymce-vue'
import EditorWizard from "../common/EditorWizard";
import editorSettings from "../../services/editorSettings";
import ImageSelector from "../group/ImageSelector";
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";
import YesNoModal from "../common/YesNoModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';
import Vue from "vue";

export default {
  name: 'group-branding-affiliates',
  components: {
    Avatar,
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbRow,
    mdbCol,
    mdbListGroup,
    mdbListGroupItem,
    dataTable,
    dataTableAdvanced,
    YesNoModal,
    EditorWizard,
    editor,
    ImageSelector
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    },
    currentUser: function () {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      columns: [
        {label: "ID", field: "id"},
        {label: "Name", field: "name"}
      ],
      groupActions: [
        {name: "select", label: "Select", color: "success", icon: "check-circle"}
      ],

      currentBrand: null,
      showBrand: false,
      showMain: true,
      changeGlobalGroupModal: false,
      addGroupModal: false,
      yesNoModal: false,
      imageCallback: null,
      showImageSelector: false,
      wizardData: null,
      showWizard: false,
      editorConfig: editorSettings.theWorksInline(),
      deleteCandidate: null,
      removeGroupModal: false
    }
  },
  mounted() {
    this.editorConfig.file_picker_callback = this.myFileBrowser
    this.editorConfig.paste_data_images = true
    this.editorConfig.images_upload_handler = this.handlePastedImage
    if (this.$route.params.id) {
      this.$store.dispatch("setExecuting", true)
      api.get("/affiliate/list?findById=" + this.$route.params.id, {}).then(
        (results) => {
          this.currentBrand = results.data.rows[0]
          this.prevEvents = this.currentBrand.prevEvents
          this.showMain = false
          this.showBrand = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  },
  methods: {
    removeGroup(g) {
      this.deleteCandidate = g
      this.removeGroupModal = true
    },
    async copyLink() {
      if (!navigator.clipboard) {
        this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
        return
      }
      try {
        let link = this.config.frontEndUrl + "/affiliate/" + this.currentBrand.uriName
        await navigator.clipboard.writeText(link)
        this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
      } catch (e) {
        this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
      }
    },
    handlePastedImage: function (blobInfo, success, failure, progress) {
      let url = "/image/create/?folder=pasted"
      this.$store.dispatch("setExecuting", true)
      api.postImage(url, blobInfo.blob()).then(
        (results) => {
          success(results.data.image.url)
          let els = document.getElementsByClassName("mce-content-body")
          if (els.length > 0) {
            let el = els[0]
            let images = el.getElementsByTagName("img")
            for (let i of images) {
              if (!i.hasAttribute("width")) {
                i.setAttribute("width", "33%");
                i.classList.add("gp-user-image-left");
              }
            }
          }

        },
        (error) => {
          failure(error.response.data, {remove: true})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    wizardDone: function (result) {
      this.currentBrand.homeHtml = result.html
      this.showWizard = false
      this.wizardData = result
      this.save()
    },
    uploadImage: function (img, success, failure) {
      let ret = {location: null}
      api.postImage("/admin/newImage/", img.blob()).then(
        (results) => {
          success(results.data)
        },
        (error) => {
          failure(error.response.data)
        });
    },
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      Vue.nextTick().then(() => {
        this.imageCallback(image.url, {width: "33%", height: ""})
      })
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      Vue.nextTick().then(() => {
        this.showImageSelector = true
        this.imageCallback = callBack
      })
    },
    newBrand: function () {
      this.currentBrand = {
        id: null,
        name: "",
        globalGroupId: null,
        globalGroupName: null,
        affiliateCode: "",
        homeHtml: "",
        uriName: "",
        primaryOwnerId: null,
        primaryOwnerName: null,
        primaryOwnerAvatar: null
      }
      this.showMain = false
      this.showBrand = true
    },
    proxyOwner: function () {
      this.$router.push("/users/" + this.currentBrand.primaryOwnerId + "/proxy")
    },
    cancelShow: function () {
      this.showMain = true
      this.currentBrand = null
      this.showBrand = false
      if (this.$route.params.id) this.$router.replace("/admin/affiliate")
    },

    openBrand: function (row) {
      this.showMain = false
      this.currentBrand = row
      this.showBrand = true
    },
    changeGlobalGroup(group, action) {
      this.changeGlobalGroupModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/globalGroup/" + this.currentBrand.id, {group: group.id}).then(
        (results) => {
          this.currentBrand.globalGroupId = group.id
          this.currentBrand.globalGroupName = group.name
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addDefaultGroup(group, action) {
      this.addGroupModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/defaultGroup/" + this.currentBrand.id, {group: group.id}).then(
        (results) => {
          this.currentBrand.defaultGroups.push(group)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doRemoveGroup() {
      this.removeGroupModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/affiliate/defaultGroup/" + this.currentBrand.id + "?group=" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.currentBrand.defaultGroups.indexOf(this.deleteCandidate)
          if (loc>-1) this.currentBrand.defaultGroups.splice(loc,1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    deleteGlobalGroup(group) {
      this.yesNoModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/affiliate/globalGroup/" + this.currentBrand.id).then(
        (results) => {
          this.currentBrand.globalGroupId = null
          this.currentBrand.globalGroupName = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/settings/", this.currentBrand).then(
        (results) => {
          this.$notify.success({message: "Saved", timeOut: 3000})
          if (!this.currentBrand.id) {
            this.currentBrand.id = results.data.id
            this.currentBrand.primaryOwnerId = results.data.primaryOwnerId
            this.currentBrand.primaryOwnerName = results.data.primaryOwnerName
            this.currentBrand.primaryOwnerAvatar = results.data.primaryOwnerAvatar
            this.$store.dispatch("setDataTableReload", true)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
